import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const bookingsFirstNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map